import { jsx as _jsx } from "react/jsx-runtime";
import * as Flags from 'country-flag-icons/react/3x2';
const flagComponents = Flags;
const resolveFlagCountryCode = (countryCode) => countryCode.toUpperCase();
export const CountryFlag = ({ countryCode, className }) => {
    const Flag = flagComponents[resolveFlagCountryCode(countryCode)];
    if (!Flag) {
        return null;
    }
    return _jsx(Flag, { "aria-hidden": "true", className: className, focusable: "false" });
};
//# sourceMappingURL=CountryFlag.js.map